"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _navigation = require("../navigation");

var _moduleLocalization = require("@eig-builder/module-localization");

var _postMessageHelper = _interopRequireDefault(require("@eig-builder/core-utils/helpers/post-message-helper"));

var _constants = require("./../constants");

var _gmbKebabMenu = _interopRequireDefault(require("./../components/gmb-kebab-menu"));

var _gmbPostReplyButton = _interopRequireDefault(require("./../components/gmb-post-reply-button"));

require("./../lang");

/**
 * GMB Specific HOC: we were not able to find a home for this component so putting it here
 */
var CustomFocusNavigation = function CustomFocusNavigation(_ref) {
  var children = _ref.children;

  var _useState = (0, _react.useState)(_constants.PAGE_TYPES.DEFAULT_PAGE_MOUNTED),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      currentPage = _useState2[0],
      updateCurrentPage = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      showDelete = _useState4[0],
      updateShowDelete = _useState4[1];

  var fireCallBack = function fireCallBack(action) {
    window.frames.siteOpenInIFrame.window.postMessage({
      type: "".concat(currentPage, "_CLICK"),
      action: action
    }, window.origin);
  };

  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined') {
      var postMessageHelper = new _postMessageHelper["default"]();
      postMessageHelper.bind(_constants.PAGE_TYPES.REVIEW_REPLY_PAGE_MOUNTED, function (event) {
        var reviewReply = event.reviewReply,
            type = event.type;
        updateShowDelete(reviewReply);
        updateCurrentPage(type);
      });
      postMessageHelper.bind(_constants.PAGE_TYPES.DASHBOARD_PAGE_MOUNTED, function (event) {
        var type = event.type;
        updateCurrentPage(type);
      });
      postMessageHelper.bind(_constants.PAGE_TYPES.INTRO_PAGE_MOUNTED, function (event) {
        var type = event.type;
        updateCurrentPage(type);
      });
    }

    return _postMessageHelper["default"].clear;
  }, []);

  switch (currentPage) {
    case _constants.PAGE_TYPES.REVIEW_REPLY_PAGE_MOUNTED:
      _navigation.Navigation.removeFakeNavigation(); // On page reload the left fake nav drawer is open. Solution works but causes flicker on reload.


      return /*#__PURE__*/_react["default"].createElement(_navigation.Navigation, null, /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.DetailBar, null, /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.LeftAlign, null, /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.BackButton, {
        paddingRight: "8px",
        onClick: function onClick() {
          return fireCallBack(_constants.CALLBACK_ACTIONS.GO_BACK_TO_REVIEWS);
        }
      }), /*#__PURE__*/_react["default"].createElement(_moduleLocalization.Typography, {
        variant: "h3",
        message: "helpers.gmbWithCustomFocusNavigation.title.reviewManagement"
      })), /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.CenterAlign, null), /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.RightAlign, null, /*#__PURE__*/_react["default"].createElement(_gmbPostReplyButton["default"], {
        fireCallBack: fireCallBack
      }), /*#__PURE__*/_react["default"].createElement(_gmbKebabMenu["default"], {
        fireCallBack: fireCallBack,
        showDelete: showDelete
      }))), /*#__PURE__*/_react["default"].createElement(_navigation.PageContent, null, children));

    case _constants.PAGE_TYPES.DASHBOARD_PAGE_MOUNTED:
    case _constants.PAGE_TYPES.INTRO_PAGE_MOUNTED:
      _navigation.Navigation.removeFakeNavigation(); // On page reload the left fake nav drawer is open. Solution works but causes flicker on reload.


      return /*#__PURE__*/_react["default"].createElement(_navigation.Navigation, null, /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.DetailBar, null, /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.LeftAlign, null, /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.BackButton, {
        paddingRight: "8px"
      }), /*#__PURE__*/_react["default"].createElement(_moduleLocalization.Typography, {
        variant: "h3",
        message: "helpers.gmbWithCustomFocusNavigation.title.businessListing"
      })), /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.CenterAlign, null)), /*#__PURE__*/_react["default"].createElement(_navigation.PageContent, null, children));

    default:
      return /*#__PURE__*/_react["default"].createElement(_navigation.Navigation, null, /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.DetailBar, null, /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.LeftAlign, null, /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.BackButton, {
        paddingRight: "8px"
      }), /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.BreadCrumbs, null)), /*#__PURE__*/_react["default"].createElement(_navigation.Navigation.CenterAlign, null)), /*#__PURE__*/_react["default"].createElement(_navigation.PageContent, null, children));
  }
};

CustomFocusNavigation.propTypes = {
  children: _propTypes["default"].element
};
var _default = CustomFocusNavigation;
exports["default"] = _default;